module.exports = __webpack_public_path__ + "img/twitter.3f2b027c.png";